import React from 'react';
import TextInputBase, { ITextInputCommonProps } from './base/TextInputBase';

interface ITextInputProps extends ITextInputCommonProps {
    label?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const TextInput: React.FC<ITextInputProps> = (props) => {
    return <TextInputBase {...props} />;
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/controls/forms/TextInput.tsx